import { render, staticRenderFns } from "./bindSpuDialog.vue?vue&type=template&id=4f31bcd4&scoped=true&"
import script from "./bindSpuDialog.vue?vue&type=script&lang=js&"
export * from "./bindSpuDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindSpuDialog.vue?vue&type=style&index=0&id=4f31bcd4&prod&lang=scss&scoped=true&"
import style1 from "./bindSpuDialog.vue?vue&type=style&index=1&id=4f31bcd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f31bcd4",
  null
  
)

export default component.exports